export default __webpack_public_path__ + "static/media/Reset.1044f08d.svg";